import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});
export async function fetchAllDataApi(url: string, options: RequestInit = {}): Promise<any> {
    try {
  
      const response = await authService.apiCall(`${BASE_URL}/${url}`, {
        ...options,
      
      });
  
      const data = await response.json();
      
      //////console.log("Response Data:", data);
  
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
       
        //toast(data.message || "Failed to fetch");
      }
  
      return data;
    } catch (error: any) {
      //console.error("Fetch Error:", error);
      throw new Error(error.message || "Failed to fetch");
    }
  }

  export async function getLatestMessages(url: string, options: RequestInit = {}): Promise<any> {
    try {

  
      const response = await authService.apiCall(`${BASE_URL}/${url}`, {
        ...options,
       
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
          }
  
      return data;
    } catch (error: any) {
      //console.error("Fetch Error:", error);
      throw new Error(error.message || "Failed to fetch");
    }
  }

  export async function fetchAllNotifications(perPage: number, pageNo: number, search: string): Promise<any> {
    try {
    
      const response = await authService.apiCall(`/notifications/user-notifications?search=${search}&perPage=${perPage}&pageNo=${pageNo}`, {
        method: "GET",
       
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
          }
  
      return data;
    } catch (error: any) {
      //console.error("Fetch Error:", error);
      throw new Error(error.message || "Failed to fetch");
    }
  }


  export async function getUnseenNotifications(userId: string): Promise<any> {
    try {
     
  
      const response = await authService.apiCall(`${BASE_URL}/notifications/unseen?userId=${userId}`, {
        method: "GET",
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
      }
  
      return data;
    } catch (error: any) {
      throw new Error(error.message || "Failed to fetch unseen notifications");
    }
  }

  export async function seenNotification(userId: string): Promise<any> {
    try {
  
      const response = await authService.apiCall(`${BASE_URL}/notifications/seen`, {
        method: 'PATCH',
       
        body: JSON.stringify({ userId }),
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
      }
  
      return data;
    } catch (error: any) {
      throw new Error(error.message || "Failed to mark notifications as seen");
    }
  }